export default "__VITE_ASSET__PY$hvK3$__"